module.exports = __webpack_public_path__ + "static/img/glxl.5f3cae68.png";